// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","banner":"_2KpQ-SVbmlIzREH4qCm3ju","header":"_3wecCRP9g1RkIu4oBPqshj","responsiveContainer":"d2TJn4q-3QoDNoT2PSMOP","subHeader":"_2zueHUOd8Juh2DFT9CjyJH"};